import React from 'react';
import styled, { css } from 'styled-components';
import { Trans } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { Flex } from '../Flex';
import Button from '../Button';
import Prompt from '../Prompt';

const Wrapper = styled(Flex)`
  background: ${({ theme }) => theme.colors.white};
  flex-direction: row-reverse;
  padding: 15px 19px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey2};

  > button {
    margin-left: 10px;
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      position: fixed;
      z-index: 2;
      bottom: 0;
      width: 100%;
    `}
`;

const ActionsBar = ({ isChanged, submitting, form, handleSubmit, canLeaveWithoutSaving }) => {
  if (!isChanged && !submitting) {
    return null;
  }

  return (
    <Wrapper isMobile={isMobileOnly}>
      <Button primary isLoading={submitting}>
        <Trans>save</Trans>
      </Button>

      <Button secondary disabled={submitting} onClick={() => form.reset()}>
        <Trans>cancel</Trans>
      </Button>

      <Prompt when onSubmit={handleSubmit} canLeaveWithoutSaving={canLeaveWithoutSaving} />
    </Wrapper>
  );
};

export default ActionsBar;
